const sticky = () => {

  const s = {}
  const init = () => {
    s.target = document.querySelector('.js-sticky');

    if (!s.target) {
      return;
    }

    s.stickyPos = getStickyPos();
    s.stickyHeight = getStickyHeight();
    s.nextEle = s.target.nextElementSibling;

    bindScrollEvent();
    bindResizeEvent();
  }

  const bindScrollEvent = () => {
    window.addEventListener('scroll', () => {
      if (s.stickyPos + s.stickyHeight > getNextElementRectTop()) {
        s.target.classList.add('is-fixed')
      } else {
        s.target.classList.remove('is-fixed')
      }
    })
  }
  const bindResizeEvent = () => {
    window.addEventListener('resize', updataValue)
  }
  const updataValue = () => {
    s.stickyPos = getStickyPos();
    s.stickyHeight = getStickyHeight();
  }

  const getStickyPos = () => {
    return Number(window.getComputedStyle(s.target).top.slice(0, -2));
  }
  const getStickyHeight = () => {
    return s.target.clientHeight;
  }
  const getNextElementRectTop = () => {
    return s.nextEle.getBoundingClientRect().top;
  }

  init();
}

export default sticky;
